module.exports = __webpack_public_path__ + "img/symbol_7.85e1ec7b.png";